function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "F15F396C-8FAF-4913-B3D9-9F04103DAF27");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M872,850 C868.1402,850 865,853.1402 865,857 C865,860.8598 868.1402,864 872,864 C875.8598,864 879,860.8598 879,857 C879,853.1402 875.8598,850 872,850 M872,862.6 C868.9123,862.6 866.4,860.0877 866.4,857 C866.4,853.9123 868.9123,851.4 872,851.4 C875.0877,851.4 877.6,853.9123 877.6,857 C877.6,860.0877 875.0877,862.6 872,862.6 M874.8,856.3 L872.7,856.3 L872.7,854.2 C872.7,853.8129 872.3871,853.5 872,853.5 C871.6129,853.5 871.3,853.8129 871.3,854.2 L871.3,856.3 L869.2,856.3 C868.8129,856.3 868.5,856.6129 868.5,857 C868.5,857.3871 868.8129,857.7 869.2,857.7 L871.3,857.7 L871.3,859.8 C871.3,860.1871 871.6129,860.5 872,860.5 C872.3871,860.5 872.7,860.1871 872.7,859.8 L872.7,857.7 L874.8,857.7 C875.1871,857.7 875.5,857.3871 875.5,857 C875.5,856.6129 875.1871,856.3 874.8,856.3",
  id: "path-add-icon"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-865.000000, -850.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-add-icon"
})), React.createElement("use", {
  id: "Icon",
  className: "use-path",
  fill: "#529C4E",
  xlinkHref: "#path-add-icon"
})));

var SvgAddIcon = function SvgAddIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-icon.be9f1e0a.svg";
export { ForwardRef as ReactComponent };